<svg
  width="16"
  height="16"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2.5 6C3.05156 6 3.5 5.55156 3.5 5C3.5 4.44844 3.05156 4 2.5 4C1.94844 4 1.5 4.44844 1.5 5C1.5 5.55156 1.94844 6 2.5 6ZM9.5 6C10.0516 6 10.5 5.55156 10.5 5C10.5 4.44844 10.0516 4 9.5 4C8.94844 4 8.5 4.44844 8.5 5C8.5 5.55156 8.94844 6 9.5 6ZM10 6.5H9C8.725 6.5 8.47656 6.61094 8.29531 6.79063C8.925 7.13594 9.37187 7.75938 9.46875 8.5H10.5C10.7766 8.5 11 8.27656 11 8V7.5C11 6.94844 10.5516 6.5 10 6.5ZM6 6.5C6.96719 6.5 7.75 5.71719 7.75 4.75C7.75 3.78281 6.96719 3 6 3C5.03281 3 4.25 3.78281 4.25 4.75C4.25 5.71719 5.03281 6.5 6 6.5ZM7.2 7H7.07031C6.74531 7.15625 6.38438 7.25 6 7.25C5.61562 7.25 5.25625 7.15625 4.92969 7H4.8C3.80625 7 3 7.80625 3 8.8V9.25C3 9.66406 3.33594 10 3.75 10H8.25C8.66406 10 9 9.66406 9 9.25V8.8C9 7.80625 8.19375 7 7.2 7ZM3.70469 6.79063C3.52344 6.61094 3.275 6.5 3 6.5H2C1.44844 6.5 1 6.94844 1 7.5V8C1 8.27656 1.22344 8.5 1.5 8.5H2.52969C2.62813 7.75938 3.075 7.13594 3.70469 6.79063Z"
    style="fill: #2C2C2C !important;"
  />
</svg>
